/* ---------- kayan şerit (JS ile, sistem "hareketi azalt" ayarından etkilenmez) ---------- */
(function(){
  var tracks = document.querySelectorAll('[data-marquee]');
  if(!tracks.length) return;

  tracks.forEach(function(el){
    var items = (el.dataset.items || '').split('|').map(function(t){return t.trim()}).filter(Boolean);
    if(!items.length) items = ['—'];
    var group = '';
    for(var r=0;r<6;r++){ items.forEach(function(t){ group += '<span>'+t+'</span>' }) }
    el.innerHTML = group + group;              // iki özdeş yarı = kusursuz döngü
    el.dataset.half = el.scrollWidth / 2;
  });

  var x = 0, last = null;
  function frame(now){
    if(last === null) last = now;
    var dt = (now - last) / 1000; last = now;
    tracks.forEach(function(el){
      var speed = parseFloat(el.parentElement.style.getPropertyValue('--mq-speed')) || 55;
      var half = parseFloat(el.dataset.half) || el.scrollWidth/2;
      el.dataset.x = ((parseFloat(el.dataset.x)||0) - speed*dt) % half;
      el.style.transform = 'translateX(' + el.dataset.x + 'px)';
    });
    requestAnimationFrame(frame);
  }
  requestAnimationFrame(frame);

  window.addEventListener('resize', function(){
    tracks.forEach(function(el){ el.dataset.half = el.scrollWidth/2 });
  });
})();

/* ---------- dil seçici ---------- */
(function(){
  var box = document.getElementById('lang');
  if(!box) return;
  var btn = box.querySelector('.lang-btn');
  btn.addEventListener('click', function(e){
    e.stopPropagation();
    var open = box.classList.toggle('open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
  document.addEventListener('click', function(){ box.classList.remove('open') });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') box.classList.remove('open') });
})();

/* ---------- paneller (menü + sepet) ---------- */
var Drawer = (function(){
  var ov = document.getElementById('overlay'),
      cart = document.getElementById('cartPanel'),
      menu = document.getElementById('menuPanel');
  function open(p){ if(!p) return; p.classList.add('show'); ov.classList.add('show'); document.body.style.overflow='hidden' }
  function closeAll(){
    [cart,menu].forEach(function(p){ if(p) p.classList.remove('show') });
    ov.classList.remove('show'); document.body.style.overflow='';
  }
  var co = document.getElementById('cartOpen'), mo = document.getElementById('menuOpen');
  if(co) co.addEventListener('click', function(){ refreshCart(); open(cart) });
  if(mo) mo.addEventListener('click', function(){ open(menu) });
  if(ov) ov.addEventListener('click', closeAll);
  document.querySelectorAll('[data-close]').forEach(function(b){ b.addEventListener('click', closeAll) });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeAll() });
  return { open: function(){ open(cart) }, close: closeAll };
})();

/* ---------- Shopify Cart API ---------- */
function money(cents){
  var fmt = (window.Shopify && Shopify.currency && Shopify.currency.active) || '';
  return (cents/100).toLocaleString(document.documentElement.lang || 'en', {minimumFractionDigits:2}) + ' ' + fmt;
}

function refreshCart(){
  fetch('/cart.js', { headers: { 'Accept':'application/json' } })
    .then(function(r){ return r.json() })
    .then(renderCart)
    .catch(function(){});
}

function renderCart(cart){
  var body = document.querySelector('[data-cart-body]'),
      foot = document.querySelector('[data-cart-foot]'),
      total = document.querySelector('[data-cart-total]');
  document.querySelectorAll('[data-cart-count]').forEach(function(el){ el.textContent = cart.item_count });
  document.querySelectorAll('[data-cart-count-text]').forEach(function(el){ el.textContent = cart.item_count });
  if(!body) return;

  if(!cart.items.length){
    body.innerHTML = '<div class="empty"><div class="star">&#11088;</div><p>Sepetin boş</p><a href="/collections/all" class="cta">Alışverişe devam et</a></div>';
    if(foot) foot.hidden = true;
    return;
  }

  body.innerHTML = cart.items.map(function(it){
    var img = it.image ? '<img src="'+it.image.replace(/(\.[a-z]+)(\?|$)/i,'_160x$1$2')+'" alt="" width="64" height="64">' : '<div class="ph" style="width:64px;height:64px"></div>';
    return '<div class="drawer-item">'+img+
      '<div><b>'+it.product_title+'</b>'+
      (it.variant_title ? '<small>'+it.variant_title+'</small>' : '')+
      '<small>'+it.quantity+' × '+money(it.final_price)+'</small></div>'+
      '<button class="rm" data-remove="'+it.key+'">Kaldır</button></div>';
  }).join('');

  if(total) total.textContent = money(cart.total_price);
  if(foot) foot.hidden = false;

  body.querySelectorAll('[data-remove]').forEach(function(b){
    b.addEventListener('click', function(){
      fetch('/cart/change.js', {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({ id: b.dataset.remove, quantity: 0 })
      }).then(function(r){ return r.json() }).then(renderCart);
    });
  });
}

/* sepete ekle: sayfayı yenilemeden çekmeceyi aç */
(function(){
  var form = document.getElementById('AddToCartForm');
  if(!form) return;
  form.addEventListener('submit', function(e){
    e.preventDefault();
    var items = [{
      id: parseInt(form.querySelector('[name="id"]').value, 10),
      quantity: parseInt((form.querySelector('[name="quantity"]') || {}).value || 1, 10)
    }];
    UPSELL.forEach(function(id){ items.push({ id: parseInt(id, 10), quantity: 1 }) });
    fetch('/cart/add.js', {
      method:'POST',
      headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function(r){ return r.json() })
      .then(function(){ refreshCart(); Drawer.open(); })
      .catch(function(){ form.submit() });
  });
})();

/* varyant seçimi */
(function(){
  var variantSelect = document.getElementById('VariantSelect');
  if(!variantSelect) return;
  var priceEl = document.getElementById('price');
  var optionSelects = document.querySelectorAll('[data-option-index]');
  function sync(){
    var values = [];
    optionSelects.forEach(function(s){ values.push(s.value) });
    var target = values.join(' / ');
    Array.prototype.forEach.call(variantSelect.options, function(o){
      if(o.textContent.trim() === target){
        variantSelect.value = o.value;
        if(priceEl && o.dataset.price) priceEl.textContent = o.dataset.price;
      }
    });
  }
  optionSelects.forEach(function(s){ s.addEventListener('change', sync) });
})();


/* ---------- karttan doğrudan sepete ekle ---------- */
(function(){
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-card-add]');
    if(!b) return;
    e.preventDefault();
    var old = b.textContent;
    b.classList.add('is-loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type':'application/json', 'Accept':'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(b.dataset.cardAdd, 10), quantity: 1 }] })
    })
    .then(function(r){ return r.json() })
    .then(function(res){
      b.classList.remove('is-loading'); b.textContent = old;
      if(res.status){ alert(res.description || res.message); return; }
      refreshCart(); Drawer.open();
    })
    .catch(function(){ b.classList.remove('is-loading'); b.textContent = old; });
  });
})();


/* ---------- VIP hediye paketi: ürün + paket -> doğrudan ödemeye ---------- */
var UPSELL = [];
(function(){
  document.querySelectorAll('button[data-upsell]').forEach(function(b){
    b.addEventListener('click', function(){
      var form = document.getElementById('AddToCartForm');
      if(!form) return;
      var variantEl = form.querySelector('[name="id"]');
      var qtyEl = form.querySelector('[name="quantity"]');
      if(!variantEl) return;

      var eski = b.innerHTML;
      b.classList.add('is-loading');
      b.innerHTML = '<span class="upsell-text">Sepete ekleniyor…</span>';

      var items = [
        { id: parseInt(variantEl.value, 10), quantity: parseInt((qtyEl || {}).value || 1, 10) },
        { id: parseInt(b.dataset.upsell, 10), quantity: 1 }
      ];

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type':'application/json', 'Accept':'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function(r){ return r.json() })
      .then(function(res){
        if(res.status){
          b.classList.remove('is-loading'); b.innerHTML = eski;
          alert(res.description || res.message);
          return;
        }
        window.location.href = '/checkout';   // doğrudan ödeme sayfası
      })
      .catch(function(){
        b.classList.remove('is-loading'); b.innerHTML = eski;
        window.location.href = '/cart';
      });
    });
  });
})();

/* ---------- aciliyet sayıları ---------- */
(function(){
  var box = document.querySelector('.urgency');
  if(!box) return;
  var path = location.pathname;
  function pick(key, el){
    if(!el) return;
    var min = parseInt(el.textContent, 10) || 10, max = min * 2, stored = null;
    try { stored = sessionStorage.getItem(key) } catch(e){}
    var n = stored ? parseInt(stored, 10) : Math.floor(min + Math.random() * (max - min + 1));
    try { sessionStorage.setItem(key, n) } catch(e){}
    el.textContent = n;
  }
  pick('urg-view-' + path, box.querySelector('[data-viewers]'));
  pick('urg-sold-' + path, box.querySelector('[data-sold]'));
  var vEl = box.querySelector('[data-viewers]');
  if(vEl) setInterval(function(){
    var n = parseInt(vEl.textContent, 10) + (Math.random() < 0.5 ? -1 : 1);
    if(n < 5) n = 5;
    vEl.textContent = n;
    try { sessionStorage.setItem('urg-view-' + path, n) } catch(e){}
  }, 9000);
})();


/* ---------- ürün galerisi: fotoğraf + video geçişi ---------- */
(function(){
  var slides = document.querySelectorAll('.media-slide');
  if(!slides.length) return;
  function show(id){
    slides.forEach(function(sl){
      var on = sl.dataset.mediaId === String(id);
      sl.classList.toggle('is-active', on);
      var vid = sl.querySelector('video');
      if(vid && !on) vid.pause();
    });
    document.querySelectorAll('.thumb').forEach(function(t){
      t.classList.toggle('is-active', t.dataset.mediaId === String(id));
    });
  }
  document.querySelectorAll('.thumb').forEach(function(t){
    t.addEventListener('click', function(){ show(t.dataset.mediaId) });
  });
})();

document.addEventListener('DOMContentLoaded', refreshCart);
